export function computeCost(
  orderQty,
  bomQty,
  components,
  usdExchangeRates,
  targetCurrency = "USD",
) {
  // This function compute the unit cost for a product, and return the used component prices
  // console.log(
  //   "computeCost",
  //   orderQty,
  //   bomQty,
  //   components,
  //   usdExchangeRates,
  //   targetCurrency,
  // );

  const sets = Math.ceil(orderQty / bomQty);

  let totalCost = 0;

  let usedComponentPriceQtys = {};
  let usedPrice = {};

  components.forEach((component, index) => {
    const componentQty = parseInt(component.qty) * sets;
    const sortedPrices = [...component.prices]
      .sort((a, b) => b.minQty - a.minQty)
      .map((i) => {
        const exchangeRate = usdExchangeRates[i.currency] || 1;
        const priceInCurrency =
          i.currency === targetCurrency
            ? i.price
            : parseFloat(i.price) / exchangeRate;
        return { ...i, priceInCurrency };
      });

    const usePrice = sortedPrices.find((price) => price.minQty <= componentQty);

    if (usePrice) {
      const componentCost = componentQty * usePrice.priceInCurrency;
      totalCost += componentCost;
      usedComponentPriceQtys[index] = usePrice.minQty;
      usedPrice[index] = { ...usePrice, componentQty, componentCost };
    }
  });

  const costPerUnit = totalCost / (sets * bomQty);

  const cnyExchangeRate = usdExchangeRates["CNY"] || 1;

  return {
    totalCost,
    costPerUnit,
    usedComponentPriceQtys,
    usedPrice,
    cnyExchangeRate,
  };
}
